import { FC } from 'react';
import { Form, Input, Select } from 'antd';

import { ADMIN_ROLE_OPTIONS } from './constants.ts';
import { TAdminFormProps, TAdminFormValues } from './types';

import { CustomForm } from '@/widgets/form';

export const AdminForm: FC<TAdminFormProps> = ({ onFinish, initialValues, ...props }) => {
    const [form] = Form.useForm();
    const isUpdate = !!initialValues;

    return (
        <CustomForm<TAdminFormValues>
            layout="vertical"
            form={form}
            onFinish={onFinish}
            initialValues={initialValues}
            requiredMark={false}
            {...props}
        >
            <CustomForm.Item<TAdminFormValues>
                label="Email Address"
                name="email"
                rules={[
                    {
                        required: true,
                        type: 'email',
                        message: 'Enter a valid email address',
                    },
                ]}
            >
                <Input disabled={isUpdate} placeholder="Enter email address" type="email" />
            </CustomForm.Item>
            <CustomForm.Item<TAdminFormValues>
                label="Role"
                name="role"
                rules={[
                    {
                        required: true,
                    },
                ]}
            >
                <Select
                    options={ADMIN_ROLE_OPTIONS}
                    labelInValue={false}
                    placeholder="Select a role"
                />
            </CustomForm.Item>
        </CustomForm>
    );
};
